import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { BodyText } from './ui';
import { getAnnouncementBanner } from '../api/services/systemService';
// import { navigateToHash } from '../utils/hashRouter';
import { isTokenExpired, navigateToLogin } from '../utils';

const AnnouncementBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2b388f;
  color: white;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  height: 42px;

  @media (max-width: 768px) {
    padding: 6px 15px;
    font-size: 12px;
    min-height: 35px;
  }

  @media (max-width: 480px) {
    padding: 5px 10px;
    font-size: 11px;
    min-height: 30px;
  }
`;

const AnnouncementContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 120px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 30px;
  }

  @media (max-width: 480px) {
    gap: 20px;
  }
`;

const AnnouncementText = styled(BodyText)`
  color: white;
  margin: 0;
  line-height: 1.4;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 12px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
  }
`;

const ClickableText = styled(AnnouncementText)`
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

const Divider = styled.div`
  width: 1px;
  height: 20px;
  background: white;
  opacity: 0.7;

  @media (max-width: 768px) {
    height: 16px;
  }

  @media (max-width: 480px) {
    height: 14px;
  }
`;

const AnnouncementBar = ({ show = true }) => {
  const userInfo = useSelector((state) => state.userInfo);
  const navigate = useNavigate();
  const [bannerData, setBannerData] = useState([]);

  useEffect(() => {
    getDbAnnouncementBanner();
  }, []);

  const getDbAnnouncementBanner = async () => {
    try {
      const result = await getAnnouncementBanner(userInfo.brandCode);
      const data = result.announcementBanner;
      setBannerData(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error(e);
    }
  };

  if (!show) return null;
  if (!bannerData.length) return null;

  const leftBanner = bannerData.find((item) => item.gubun === '0');
  const rightBanner = bannerData.find((item) => item.gubun === '1');

  const handleClick = (url) => {
    if (!url) return;

    const token = localStorage.getItem('token');

    // Check if user is logged in
    if (!token || isTokenExpired(token)) {
      // Redirect to login page if not logged in
      navigateToLogin(navigate, url);
    } else if (url.startsWith('http://') || url.startsWith('https://')) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      navigate(url);
    }
  };

  return (
    <AnnouncementBarWrapper>
      <AnnouncementContent>
        {leftBanner?.title && (
          <ClickableText onClick={() => handleClick(leftBanner.url)}>
            {leftBanner.title}
          </ClickableText>
        )}

        {leftBanner?.title && rightBanner?.title && <Divider />}

        {rightBanner?.title && (
          <ClickableText onClick={() => handleClick(rightBanner.url)}>
            {rightBanner.title}
          </ClickableText>
        )}
      </AnnouncementContent>
    </AnnouncementBarWrapper>
  );
};

export default AnnouncementBar;
